define('maps/basemap',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.BaseMap = void 0;
    /**
     * Generic map.
     */
    var BaseMap = /** @class */ (function () {
        function BaseMap(options) {
            this.layers = [];
            this.defaultCenter = { lat: 39, lng: -100 }; // USA
            this.defaultZoom = 4; // USA
            this.options = options;
        }
        BaseMap.prototype.initGoogle = function (element) {
            this.googleMap = new google.maps.Map(element, {
                center: this.options.center || this.defaultCenter,
                draggableCursor: this.options.draggableCursor,
                mapTypeId: google.maps.MapTypeId.HYBRID,
                maxZoom: this.options.maxZoom,
                scaleControl: true,
                zoom: this.options.zoom || this.defaultZoom
            });
        };
        BaseMap.prototype.setCenter = function (ll) {
            if (this.googleMap) {
                this.googleMap.setCenter(ll);
            }
        };
        BaseMap.prototype.setZoom = function (zoom) {
            if (this.googleMap) {
                this.googleMap.setZoom(zoom);
            }
        };
        /**
         * Subscribe to mouse moves as lat/lng.
         * Sends undefined on mouseout.
         */
        BaseMap.prototype.onMouseMove = function (cb) {
            if (this.googleMap) {
                google.maps.event.addListener(this.googleMap, "mousemove", function (event) {
                    cb({
                        lat: event.latLng.lat(),
                        lng: event.latLng.lng()
                    });
                });
                google.maps.event.addListener(this.googleMap, "mouseout", function () {
                    cb(undefined);
                });
            }
        };
        BaseMap.prototype.addLayer = function (layer) {
            if (layer && this.layers.indexOf(layer) < 0) {
                this.layers.push(layer);
                if (this.googleMap) {
                    layer.onAddGoogle(this.googleMap);
                }
            }
        };
        BaseMap.prototype.removeLayer = function (layer) {
            if (layer) {
                this.layers = this.layers.filter(function (l) { return l !== layer; });
                layer.onRemove();
            }
        };
        return BaseMap;
    }());
    exports.BaseMap = BaseMap;
});
//# sourceMappingURL=/assets/javascripts/maps/basemap.js.map;
